import { useContext, useEffect, useState } from 'react';

import LoginRequest from '../login-request/login-request';

import Breadcrumb from '@/components/atoms/breadcrumb/breadcrumb';
import ToBeAwareImage from '@/components/atoms/to-be-aware-image/toBeAwareImage';
import BussinesHistoricForm from '@/components/molecules/bussines-historic-form/bussines-historic-form';

import GlobalContext from '../../../contexts/globalContext';

import BusinessModal from '@/components/molecules/bussiness-modal/businessModal';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';

import './bussines-historical.scss';
import useLoginGigya from '@/shared/hooks/useLoginGigya';

import { NodeQueryType } from './bussines-historical-types';

type BussinesHistoricalProps = {
  dataQuery: NodeQueryType;
};

const BussinesHistorical = ({ dataQuery }: BussinesHistoricalProps) => {
  const { business } = useContext(GlobalContext);
  const gigyaContext = useLoginGigya();

  const [bussinesModal, setBussinesModal] = useState(false);
  const [needSesion, setNeedSesion] = useState(true);
  const [, setShowConfirmation] = useState(true);

  useEffect(() => {
    if (!business?.get) {
      setBussinesModal(true);
    }
  }, [business]);

  useEffect(() => {
    if (gigyaContext.gigyaAccount) {
      setNeedSesion(false);
    }
  }, [gigyaContext.gigyaAccount]);

  return (
    <GeneralPageTemplate data={dataQuery?.metaInfo[0]} hasLoader={false} isPrivate={false} isActive>
      {needSesion ? (
        <LoginRequest />
      ) : (
        <div className="bussines-historical">
          <div className="bussines-historical__bread">
            <Breadcrumb content={dataQuery?.migaDePan} />
          </div>

          <h1 className="bussines-historical__title">{dataQuery?.nombre}</h1>

          <div className="bussines-historical__content">
            <div>
              <ToBeAwareImage image={dataQuery.imagen[0]} content={dataQuery.descripcion} />
            </div>
            <div style={{ width: '100%' }}>
              {bussinesModal && (
                <BusinessModal
                  closeModal={() => setBussinesModal(false)}
                  isMobile
                  setShowConfirmation={setShowConfirmation}
                  isPrivate={false}
                  closeModalPermissionPage={() => setBussinesModal(false)}
                  serviceId={dataQuery.serviceId}
                />
              )}
              <BussinesHistoricForm
                business={business}
                gigyaAccount={gigyaContext.gigyaAccount}
                docTypesList={dataQuery?.referencias[0].listaJson}
                dataQuery={dataQuery}
              />
            </div>
          </div>
        </div>
      )}
    </GeneralPageTemplate>
  );
};

export default BussinesHistorical;
